import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["input"];
  }

  connect() {
    this.inputWidth = this.dynamicInputWidth;
  }

  set inputWidth(width) {
    this.inputTarget.style.width = `${width}px`;
  }

  get dynamicInputWidth() {
    return this.placeholderLength * this.fontSizeFloat * 0.6;
  }

  get placeholderLength() {
    return this.inputTarget.getAttribute("placeholder").length;
  }

  get fontSizeFloat() {
    return parseFloat(this.fontSize);
  }

  get fontSize() {
    return window.getComputedStyle(this.inputTarget).fontSize;
  }
}
